module.exports = __webpack_public_path__ + "assets/images/scene-2_32f428a5bc92ea2a798b026bd273988c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-one/croma-abeldo-dialogs/scene-2.png
// module id = 201
// module chunks = 0